export const SE_TASK_UPDATE_RATE = 30000;  // 30 seconds
export const YT_TASK_UPDATE_RATE = 5000;  // 5 seconds
export const TG_TASK_UPDATE_RATE = 5000;  // 5 seconds
export const AVITO_TASK_UPDATE_RATE = 5000;  // 5 seconds
export const SITE_PARSER_UPDATE_RATE = 5000;  // 5 seconds

const API_VERSION = 'v1';

export const API_DOMAIN = '/api/' + API_VERSION;


export const catalogsMatcherEndpoint = 'catalogs-mather';
